import { render, staticRenderFns } from "./ExpeditionInvoiceDetail.vue?vue&type=template&id=d3549b76&"
import script from "./ExpeditionInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./ExpeditionInvoiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports